export default "__VITE_ASSET__82978c54__"